<!--
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2023-12-27 15:06:14
 * @FilePath: /smartEarthDemo/src/demo/earth/words.vue
 * @Description: 
-->
<template>
    <div id="cesiumContainer">

    </div>
</template>
<script>
import * as Cesium from "cesium/Cesium";
import widget from "cesium/Widgets/widgets.css";
export default {
    data () {
        return {

        }
    },
    mounted(){
     this.init()
    },
    methods:{
        init () {
               let viewerOption = {
                    geocoder: false, // 地理位置查询定位控件
                    homeButton: false, // 默认相机位置控件
                    timeline: false, // 时间滚动条控件
                    navigationHelpButton: false, // 默认的相机控制提示控件
                    fullscreenButton: false, // 全屏控件
                    scene3DOnly: true, // 每个几何实例仅以3D渲染以节省GPU内存
                    baseLayerPicker: false, // 底图切换控件
                    animation: false, // 控制场景动画的播放速度控件
                    shouldAnimate: true,
                
                    //关闭星星
                    skyBox: new Cesium.SkyBox({
                        show: true
                    }),
                    //   imageryProvider: new Cesium.UrlTemplateImageryProvider({
                    //     url:'http://mt2.google.cn/vt/lyrs=m@167000000&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}&s=Galil',
                    //     tilingScheme:new Cesium.WebMercatorTilingScheme(),
                    //     minimumLevel:1,
                    //     maximumLevel:20
                    // }),
                    baseLayerPicker: false
                };
                let viewer = new Cesium.Viewer(this.$el, viewerOption);

                viewer.scene.sun.destroy(); //去掉太阳
                viewer.scene.sun = undefined; //去掉太阳
                viewer.scene.moon.destroy(); //去掉月亮
                viewer.scene.moon = undefined; //去掉月亮
                viewer._cesiumWidget._creditContainer.style.display = "none";// 隐藏版权
                //添加文字
                var labels=viewer.scene.primitives.add(new Cesium.LabelCollection());
               viewer.entities.add({
                position: Cesium.Cartesian3.fromDegrees(116.298782, 40.047983),
                // billboard:{
                //     image : 'img/marker.png',
                // },
                label:{
                    text: 'Hello Wrold',
                    fillColor: Cesium.Color.RED,
                    font: '30px Calibri',
                    outlineWidth: 1.0,
                    style: Cesium.LabelStyle.FILL_AND_OUTLINE
                 },
               });
                viewer.camera.flyTo({
                  destination : Cesium.Cartesian3.fromDegrees(116.298782, 40.047983,300),
               });
            },
        }
    
}
</script>
<style scoped>
     #cesiumContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>